import { jsx as _jsx } from "react/jsx-runtime";
export const Turn = () => {
    return (_jsx("svg", Object.assign({ style: { marginTop: '-0.4rem', opacity: 1 }, width: '16', viewBox: '0 0 16 25', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("g", Object.assign({ id: 'Trail' }, { children: _jsx("path", { id: 'line', d: 'M8 0L8 7.99988C8 12.4182 11.5817 15.9999 16 15.9999V15.9999', stroke: '#e8e8e8' }) })) })));
};
